import React from "react";
import { fileExtLabel } from "./utils";

export function AttachmentFileIcon({ filename, busy }) {
  const label = fileExtLabel(filename);
  return (
    <span
      className={`ea-file-icon ${busy ? "busy" : ""}`}
      data-ext={label.toLowerCase()}
      aria-hidden="true"
    >
      {busy ? (
        <span className="ea-attach-spinner" />
      ) : (
        <>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.75">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M7 3h7l5 5v13a1 1 0 01-1 1H7a1 1 0 01-1-1V4a1 1 0 011-1z"
            />
            <path strokeLinecap="round" strokeLinejoin="round" d="M14 3v5h5" />
          </svg>
          <span className="ea-file-icon-ext">{label}</span>
        </>
      )}
    </span>
  );
}

export function InvestigationLedger({ investigation }) {
  const ledger = investigation?.ledger;
  if (!ledger) return null;
  const items = [
    { key: "graph", label: "Graph" },
    { key: "catalog", label: "Catalog" },
    { key: "evidence", label: "Evidence" },
  ];
  return (
    <div className="investigation-ledger-section">
      <div className="investigation-ledger-title">Investigation coverage</div>
      <ul className="investigation-ledger-list">
        {items.map(({ key, label }) => (
          <li
            key={key}
            className={`investigation-ledger-item ${
              ledger[key] ? "ledger-done" : "ledger-pending"
            }`}
          >
            <span className="ledger-mark">{ledger[key] ? "✓" : "○"}</span>
            <span>{label}</span>
          </li>
        ))}
      </ul>
    </div>
  );
}
